var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('v-data-table', {
    staticClass: "v-data-table--default",
    attrs: {
      "items": _vm.questions,
      "headers": _vm.questionsHeaders,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "mobile-breakpoint": "768"
    },
    scopedSlots: _vm._u([{
      key: "item.subject",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('router-link', {
          staticClass: "d-block font-weight-medium text-truncate",
          attrs: {
            "to": "/center/questions/".concat(item._id)
          }
        }, [_vm._v(_vm._s(item.subject))]);
      }
    }, {
      key: "item.no",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('span', {}, [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + +_vm.questions.indexOf(item) + 1))]);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }, {
      key: "item.answer",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return _c('span', {}, [item.answer ? _c('span', [_vm._v("답변")]) : _c('span', [_vm._v("미답변")])]);
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return _c('span', {}, [_c('div', {
          staticClass: "v-btn--group--x-small"
        }, [item.answer ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "color": "grey"
          },
          on: {
            "click": function click($event) {
              return _vm.details(item);
            }
          }
        }, [_vm._v("답변")]) : _c('v-btn', {
          attrs: {
            "x-small": "",
            "color": "secondary"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("수정")]), _c('v-btn', {
          staticClass: "white",
          staticStyle: {
            "border-color": "#9e9e9e!important"
          },
          attrs: {
            "x-small": "",
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('span', {
          staticClass: "grey--text text--darken-3"
        }, [_vm._v("삭제")])])], 1)]);
      }
    }])
  })], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "border-color": "#9e9e9e!important"
    },
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("작성하기")])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }